import React, { FC } from "react";
import { useParams } from "react-router-dom";

const CardDetailPage: FC = () => {
  const { id } = useParams<{ id: string }>();

  return (
    <main className="p-8 max-w-4xl mx-auto">
      <h1 className="text-3xl font-bold mb-6">Детали карточки: {id}</h1>
      <p>Здесь можно показывать более подробную информацию о карточке, например, описание, графики и т. д.</p>
    </main>
  );
}

export default CardDetailPage;
